// types
import { Pool } from 'components/types';
import { Employer } from 'components/admin-portal/Tables/Employer/EmployerCostSettings/EmployerCostSettings.types';
import {
  NoEmployeePoolOption,
  NoEmployerOption,
  NoPoolOption
} from './FilterComponent.types';

export const isNoEmployerOption = (
  employer: Employer | NoEmployerOption | null
): employer is NoEmployerOption => {
  return !!employer && (employer as NoEmployerOption).noEmployer === true;
};

export const isNoPoolOption = (
  pool: Pool | NoPoolOption | null
): pool is NoPoolOption => {
  return !!pool && (pool as NoPoolOption).noPool === true;
};

export const isNoEmployeeOption = (
  empPool: Pool | NoEmployeePoolOption | null
): empPool is NoEmployeePoolOption => {
  return !!empPool && (empPool as NoEmployeePoolOption).noEmployeePool === true;
};
